(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elevar-customizations"] && !Shopify.designMode) return;
  try {
    const enrichProductWithCategories = (productRow, lookup) => {
        if (productRow == null || typeof productRow !== 'object') {
            return productRow;
        }
        if (lookup == null || typeof lookup !== 'object') {
            return productRow;
        }
        const productId = productRow.product_id != null ? String(productRow.product_id) : '';
        if (productId === '') {
            return productRow;
        }
        const categories = lookup[productId];
        if (categories == null) {
            return productRow;
        }
        const next = { ...productRow };
        if (categories.item_category2 != null && String(categories.item_category2) !== '') {
            next.item_category2 = categories.item_category2;
        }
        if (categories.item_category3 != null && String(categories.item_category3) !== '') {
            next.item_category3 = categories.item_category3;
        }
        return next;
      };

      const mapProductArray = (products, lookup) => {
        if (!Array.isArray(products)) {
            return products;
        }
        return products.map((row) => enrichProductWithCategories(row, lookup));
      };

      const enrichElevarEcommerceEvent = (item) => {
        const lookup = window.__elevarProductCategoryMetafields;
        if (lookup == null || item.ecommerce == null) {
            return item;
        }
        const ecommerce = item.ecommerce;
        const nextEcommerce = { ...ecommerce };

        if (Array.isArray(nextEcommerce.items)) {
            nextEcommerce.items = mapProductArray(nextEcommerce.items, lookup);
        }
        if (nextEcommerce.detail != null && Array.isArray(nextEcommerce.detail.products)) {
            nextEcommerce.detail = {
                ...nextEcommerce.detail,
                products: mapProductArray(nextEcommerce.detail.products, lookup),
            };
        }
        if (nextEcommerce.add != null && Array.isArray(nextEcommerce.add.products)) {
            nextEcommerce.add = {
                ...nextEcommerce.add,
                products: mapProductArray(nextEcommerce.add.products, lookup),
            };
        }
        if (nextEcommerce.purchase != null && Array.isArray(nextEcommerce.purchase.products)) {
            nextEcommerce.purchase = {
                ...nextEcommerce.purchase,
                products: mapProductArray(nextEcommerce.purchase.products, lookup),
            };
        }
        if (nextEcommerce.checkout != null && Array.isArray(nextEcommerce.checkout.products)) {
            nextEcommerce.checkout = {
                ...nextEcommerce.checkout,
                products: mapProductArray(nextEcommerce.checkout.products, lookup),
            };
        }

        return { ...item, ecommerce: nextEcommerce };
      };

      window.ElevarTransformFn = (item) => {
        const userLocale = window.Shopify.routes.root.split("/").filter(Boolean).join("").replace('-', '_');
        if (item.event === "dl_user_data") {
            return {
                ...item,
                ecommerce: {
                    ...item.ecommerce,
                    locale: userLocale
                }
            };
        }

        if (item.event === "dl_view_item" || item.event === "dl_add_to_cart" || item.event === "dl_purchase") {
            return enrichElevarEcommerceEvent(item);
        }

        return item;
      };
  } catch(e) { console.error(e); }
})();

})();
